var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { useTheme } from "styled-components";
import { FloatingArrow } from "@floating-ui/react";
import { zIndex, ZTooltip } from "../../styled_components";
const getVariants = ({ colors: { tooltipColors } }) => ({
    dark: {
        backgroundColor: tooltipColors.darkBackground,
        color: tooltipColors.darkText,
    },
    light: {
        backgroundColor: tooltipColors.lightBackground,
        color: tooltipColors.lightText,
    },
    table: {
        backgroundColor: tooltipColors.tableBackground,
        color: tooltipColors.tableText,
    },
});
const DEFAULT_VARIANT = "dark";
const StyledToolTip = styled.span `
  ${({ floatingStyles, theme, variant = DEFAULT_VARIANT }) => (Object.assign(Object.assign({}, getVariants(theme)[variant]), floatingStyles))}
  z-index: ${zIndex(ZTooltip)};
  ${({ theme: { sizes, shadows: { floatingBox }, }, variant, }) => ({
    borderRadius: sizes[1],
    boxShadow: floatingBox,
    boxSizing: "border-box",
    display: "block",
    fontSize: "12px",
    maxWidth: sizes[8],
    padding: variant === "table" ? 0 : "3px 8px",
})}
`;
export const TooltipBubble = (_a) => {
    var { arrowRef, children, context, floatingStyles, floatingProps, targetElemRef, testId = "TooltipBubble", variant = DEFAULT_VARIANT } = _a, props = __rest(_a, ["arrowRef", "children", "context", "floatingStyles", "floatingProps", "targetElemRef", "testId", "variant"]);
    const theme = useTheme();
    // If there is no content for the tooltip, don't show an empty reactangle with an arrow
    if (!children)
        return null;
    return (React.createElement(StyledToolTip, Object.assign({ "data-testid": testId, floatingStyles: floatingStyles, role: "tooltip", variant: variant }, floatingProps, { ref: targetElemRef }, props),
        children,
        variant !== "table" && (React.createElement(FloatingArrow, { ref: arrowRef, context: context, fill: variant === "light" ? theme.colors.tooltipColors.lightBackground : theme.colors.tooltipColors.darkBackground }))));
};
